// extracted by mini-css-extract-plugin
module.exports = {"Section":"Order_Section__UUFWX","Container":"Order_Container__M7MCz"};